import { HttpClient } from "../../utils/api/http-client";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import {
  IDailyStockCount,
  IDailyStockEntry,
} from "../../models/wms/daily-stock-count";

export default class DailyStockCountService {
  constructor(private http: HttpClient<unknown>) {}

  list = (storeId: number, day: string) =>
    this.http.request<IBaseListingResponse<IDailyStockCount>>({
      path: "/wms/daily-stock-counts",
      method: "GET",
      query: { storeId, day, perPage: -1 },
    });

  record = (storeId: number, day: string, entries: IDailyStockEntry[]) =>
    this.http.request<{ data: IDailyStockCount[] }>({
      path: "/wms/daily-stock-counts",
      method: "POST",
      body: { storeId, day, entries },
    });

  correct = (
    id: number,
    data: {
      quantity: number;
      countedAt: string | null;
      expectedVersion: number;
    },
  ) =>
    this.http.request<IDailyStockCount>({
      path: `/wms/daily-stock-counts/${id}`,
      method: "PUT",
      body: data,
    });

  history = (id: number) =>
    this.http.request<IDailyStockCount>({
      path: `/wms/daily-stock-counts/${id}`,
      method: "GET",
    });
}
